import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppService } from '../../services/app.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent implements OnInit, OnDestroy {
  assetsUrl: string = '';
  private $appData: Subscription;
  data: any = {};

  constructor(appService: AppService, private apiService: ApiService) {
    this.assetsUrl = appService.ENV.ASSETS_BASE_URL;
    this.$appData = this.apiService.$appData.subscribe((data: any) => { this.data = data });
  }

  ngOnInit() {
    var data = this.apiService.getData();
    this.data = data;
  }

  ngOnDestroy(): void {
    this.$appData.unsubscribe();
  }

}
